<template>
    <article>
        <div class="down_wrapper">
            <h1>Wir sind derzeit wegen Wartungsarbeiten nicht erreichbar. Wir werden bald zurück sein!</h1>
            <p>Entschuldigen Sie die Unannehmlichkeiten, aber wir führen derzeit einige Wartungsarbeiten durch. Wenn Sie möchten, können Sie uns jederzeit <a href="https://www.headandshoulders.de/de-de/contact-us">kontaktieren</a>. Andernfalls sind wir in Kürze wieder online!</p>
            <img class="down_img" src="../../public/assets/maintenance.svg" alt="Site Down" />
        </div>
</article>
</template>
<script>
export default {
  name: "sitedown"
}
</script>
<style>
  body {
      text-align: center;
      padding: 15px;
      padding-top: 100px;
      font-size: 20px;
      color: #000000 !important;
    }
  h1 {
      font-size: 32px;
    }
  article {
      display: block;
      text-align: center;
      margin: 0 auto;
    }
  a {
      color: var(--brand-color);
      text-decoration: none;
    }
  a:hover {
      color: #333;
      text-decoration: none;
    }
  .down_wrapper {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }
  .down_wrapper p, h1 {
      max-width: 650px;
      color: #000000;
    }
  .down_img {
      margin-top: 40px;
      width: 100%;
      height: calc(200px + 15vw);
    }
</style>
